import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroContent, images } from '../../data/mock';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[700px] bg-black">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={images.salonInterior}
          alt="Modern salon"
          className="w-full h-full object-cover opacity-80"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/15 to-black/30" />
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col justify-end pb-20 lg:pb-32 px-6 lg:px-12">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-medium text-white leading-tight mb-8">
          We Built a Website & Client Portal for Your Business<br />Free!
        </h1>
        <div className="max-w-4xl">
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-3 bg-accent-orange text-white px-8 py-4 text-lg font-medium hover:bg-accent-orange/90 transition-colors"
          >
            Get it Launched!
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Announcement Bar */}
      <div className="absolute bottom-0 left-0 right-0 bg-accent-green py-3 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap">
          <span className="text-black font-medium mx-8">No setup fees</span>
          <span className="text-black/60">•</span>
          <span className="text-black font-medium mx-8">No obligation</span>
          <span className="text-black/60">•</span>
          <span className="text-black font-medium mx-8">Just £30 per month for hosting if you decide to go live</span>
          <span className="text-black/60">•</span>
          <span className="text-black font-medium mx-8">No setup fees</span>
          <span className="text-black/60">•</span>
          <span className="text-black font-medium mx-8">No obligation</span>
          <span className="text-black/60">•</span>
          <span className="text-black font-medium mx-8">Just £30 per month for hosting if you decide to go live</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
